import React, { useEffect } from 'react';
import { View } from 'react-native';
import { Colors } from 'react-native-paper';
import { AppButton } from '../../../components/form';

import styles from './styles';
import { AppHeader } from '../../../components/common';

import { Logout } from '../../../config/utils';

const HireTrainer = ({ navigation }) => {
  useEffect(() => {
    Logout(navigation);

    navigation.navigate('Profile Trainer', {
      screen: 'Subscriptions',
    });
  }, []);
  return (
    <View style={styles.viewBase}>
      <AppHeader title={'Contratar\nPersonal Trainer'} navigation={navigation} />
      <View style={styles.content} />
      <AppButton label="SAIR" rippleColor={Colors.white} style={styles.buttonBack} labelStyle={styles.textBack} onPress={() => navigation.goBack()} />
    </View>
  );
};
export default HireTrainer;
